/** @format */

import {styled} from '@mui/material/styles';

const PREFIX = 'CategoryNew';

const classes = {
  infoTitle: `${PREFIX}-infoTitle`,
  infoValue: `${PREFIX}-infoValue`,
  categoryIcon: `${PREFIX}-categoryIcon`,
  categoryTitle: `${PREFIX}-categoryTitle`,
  downloadReportButton: `${PREFIX}-downloadReportButton`,
  categoryDescription: `${PREFIX}-categoryDescription`,
  categorySubtitle: `${PREFIX}-categorySubtitle`,
  infoPlate: `${PREFIX}-infoPlate`,
};

const BunchRoot = styled('div')(({theme}) => ({
  [`& .${classes.infoTitle}`]: {
    color: '#8F8F8F',
    fontSize: 14,
    fontWeight: 400,
  },

  [`& .${classes.infoValue}`]: {
    color: theme.palette.text.primary,
    fontSize: 20,
    fontWeight: 500,
    marginTop: theme.spacing(2),
  },

  [`& .${classes.categoryIcon}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: theme.spacing(4),
    width: '48px',
    height: '48px',
    borderRadius: theme.spacing(2),
    background: '#202020',
  },

  [`& .${classes.categoryTitle}`]: {
    fontSize: '24px',
    fontWeight: 700,
  },

  [`& .${classes.downloadReportButton}`]: {
    padding: theme.spacing(4, 8),
    borderRadius: theme.spacing(2),
    background: '#202020',
    boxShadow: '1px 1px 5px 0px rgba(0, 0, 0, 0.05)',
    color: '#F1F1F1',
    fontSize: '14px',
    fontWeight: 400,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginTop: theme.spacing(4),
    },
    '&:hover': {
      background: '#202020',
    },
  },

  [`& .${classes.categoryDescription}`]: {
    padding: theme.spacing(4),
    borderRadius: theme.spacing(2),
    background: '#202020',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '18px',
  },

  [`& .${classes.categorySubtitle}`]: {
    color: '#FFF',
    fontSize: '20px',
    fontWeight: 700,
    lineHeight: 'normal',
    letterSpacing: '0.225px',
  },

  [`& .${classes.infoPlate}`]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flexGrow: 1,
    marginRight: theme.spacing(2),
    padding: theme.spacing(4, 0),
    borderRadius: theme.spacing(2),
    background: '#202020',
    '&:last-of-type': {
      marginRight: 0,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginTop: theme.spacing(2),
      marginRight: 0,
      ['&:first-of-type']: {
        marginTop: 0,
      },
    },
  },
}));

export {classes as bunchClasses, BunchRoot};
